import React from 'react';
import { useSession } from '../SessionProvider/SessionProvider';
import { IdleUserTimeout } from '../../components/IdleUserTimeout';
import { useConfig } from '../ConfigProvider';

const IdleUserTimeoutProvider: React.FC = () => {
  const { logout } = useSession();
  const { IDLE_TIMEOUT_IN_MINS, IDLE_POPUP_WAITING_TIME_IN_MINS } = useConfig();
  return (
    <IdleUserTimeout
      timeoutMinutes={IDLE_TIMEOUT_IN_MINS - IDLE_POPUP_WAITING_TIME_IN_MINS}
      onTimeout={logout}
      waitTimeMinutes={IDLE_POPUP_WAITING_TIME_IN_MINS}
    />
  );
};

export default IdleUserTimeoutProvider;
